import Image from "next/image";
import { cn } from "@/lib/utils";
import Link from "next/link";

type LogoProps = {
  className?: string;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

const Logo = ({ className, href, onClick }: LogoProps) => {
  if (!href) {
    return (
      <Image
        src="https://cdn-crayo.com/lp/public/crayoBlue.png"
        alt="Crayo Logo"
        width={120}
        height={40}
        draggable={false}
        style={{
          userSelect: "none",
          pointerEvents: "none",
          touchAction: "none",
        }}
        className={cn(className)}
      />
    );
  }

  return (
    <Link href={href} onClick={onClick}>
      <Image
        src="https://cdn-crayo.com/lp/public/crayoBlue.png"
        alt="Crayo Logo"
        width={120}
        height={40}
        draggable={false}
        style={{
          userSelect: "none",
          pointerEvents: "none",
          touchAction: "none",
        }}
        className={cn(className)}
      />
    </Link>
  );
};

export default Logo;
